const NUM_CASH = 1;
const NUM_CREDIT_CARD = 2;

export default {
  NUM_CASH,
  NUM_CREDIT_CARD
};
